module.exports = require('../dist/components/Type/Type');
